export default "__VITE_ASSET__DQrRX1rY__"